import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import ToolTipList from '../ToolTipList/ToolTipList'

const ProductTypeChip = ({ productTypes, isEnabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getLabel = () => {
    if (productTypes?.length) {
      return `${productTypes.length} ${productTypes.length > 1 ? t('tipos de producto') : t('tipo de producto')}`
    }

    return t('Todos los productos')
  }

  return (
    <Chip
      label={getLabel()}
      disabled={!isEnabled}
      backgroundColor={theme.colors.warning.surface}
      color={theme.colors.warning.onSurface}
      tooltipContent={productTypes?.length > 0 && <ToolTipList items={productTypes} />}
    />
  )
}

export default ProductTypeChip
